import Vue from "vue";
import Router from "vue-router";
import Map from "./views/map.vue";
import Removal from "./views/removal.vue";
import Row from "./views/row.vue";
import Carbon from "./views/carbon.vue";
import FitureCarbon from "./views/carbon_future.vue";
import PastCarbon from "./views/carbon_past.vue";

Vue.use(Router);

export default new Router({
  base: __dirname,
  mode: "history",
  routes: [
    { path: "/", name: "map", component: Map },
    {
      path: "/removal",
      name: "removal",
      component: Removal
    },
    {
      path: "/row/:total/:start/:end",
      name: "row",
      component: Row
    },
    {
      path: "/carbon/:total/:start/:end",
      name: "carbon",
      component: Carbon
    },
    {
      path: "/carbon_future/:total/:start/:end",
      name: "future_carbon",
      component: FitureCarbon
    },
    {
      path: "/carbon_past/:total/:start/:end",
      name: "carbon_past",
      component: PastCarbon
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router.js